export default __webpack_public_path__ + "static/media/(82).e49054dd.jpg";